import { useState, useEffect } from 'react';
import { loadDemoStatuses } from '../demo/demoData';

function useEnumStatuses() {
  const [enumStatuses, setEnumStatuses] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchStatuses = async () => {
    try {
      const data = await loadDemoStatuses('enums');
      setEnumStatuses(data || {});
    } catch (err) {
      setError('Failed to fetch enum statuses: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStatuses();
  }, []);

  const updateStatus = async (enumName, enabled) => {
    setLoading(true);
    try {
      setEnumStatuses(prev => ({
        ...prev,
        [enumName]: { ...(prev[enumName] || {}), enabled }
      }));
      return true;
    } catch (err) {
      setError(`Failed to ${enabled ? 'enable' : 'disable'} ${enumName}: ${err.message}`);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { 
    enumStatuses,
    loading, 
    error, 
    updateStatus,
    refreshStatuses: fetchStatuses 
  };
}

export default useEnumStatuses; 